import { environment } from '@front-app-environments/environment'
import { ActionReducer, ReducerManager } from '@ngrx/store'
import { activityOns } from '../scene/crop-management/crop/store/reducers/activity.reducer'
import { cropDetailOns, initialCropDetailState } from '../scene/crop-management/crop/store/reducers/crop-detail.reducer'
import { cropOns, initialCropState } from '../scene/crop-management/crop/store/reducers/crop.reducer'
import { interventionOns } from '../scene/crop-management/crop/store/reducers/intervention.reducer'
import { initialOfflineState, offlineOns } from '../scene/crop-management/crop/store/reducers/offline.reducer'
import { recommendationOns } from '../scene/crop-management/crop/store/reducers/recommendation.reducer'
import { scoutingOns } from '../scene/crop-management/crop/store/reducers/scouting.reducer'
import {
  initialSpecificationState,
  specificationOns,
} from '../scene/crop-management/crop/store/reducers/specification.reducer'
import { initialVarietyState, varietyOns } from '../scene/crop-management/crop/store/reducers/variety.reducer'
import { farmOns, initialFarmState } from '../scene/crop-management/farm/store/reducers/farm.reducer'
import { fieldOns, initialFieldState } from '../scene/crop-management/farm/store/reducers/field.reducer'
import { Features } from './features.enum'
import { IdbStorageService } from './idb-storage.service'

export function idbReducer(reducerManager: ReducerManager, storage: IdbStorageService) {
  return async () => {
    try {
      const [
        farmIdbRehydrateReducer,
        fieldIdbRehydrateReducer,
        cropIdbRehydrateReducer,
        cropDetailIdbRehydrateReducer,
        offlineIdbRehydrateReducer,
        varietyStateIdbRehydrateReducer,
        specificationStateIdbRehydrateReducer,
      ] = await Promise.all([
        await storage.createIdbRehydrateReducer(Features.FARM, initialFarmState, ...farmOns),
        await storage.createIdbRehydrateReducer(Features.FIELD, initialFieldState, ...fieldOns),
        await storage.createIdbRehydrateReducer(Features.CROP, initialCropState, ...cropOns),
        await storage.createIdbRehydrateReducer(
          Features.CROP_DETAIL,
          initialCropDetailState,
          ...cropDetailOns,
          ...scoutingOns,
          ...recommendationOns,
          ...interventionOns,
          ...activityOns,
        ),
        await storage.createIdbRehydrateReducer(Features.OFFLINE, initialOfflineState, ...offlineOns),
        await storage.createIdbRehydrateReducer(Features.VARIETY, initialVarietyState, ...varietyOns),
        await storage.createIdbRehydrateReducer(Features.SPECIFICATION, initialSpecificationState, ...specificationOns),
      ])

      reducerManager.addReducers({
        farm: farmIdbRehydrateReducer,
        field: fieldIdbRehydrateReducer,
        crop: cropIdbRehydrateReducer,
        cropDetail: cropDetailIdbRehydrateReducer,
        offline: offlineIdbRehydrateReducer,
        variety: varietyStateIdbRehydrateReducer,
        specification: specificationStateIdbRehydrateReducer,
      })
    } catch (err) {
      console.error('[idbReducer] IndexedDB initialisation failed, continuing without offline state:', err)
    }
  }
}

export function debug<S>(reducer: ActionReducer<S>): ActionReducer<S> {
  return function (state, action) {
    const nextState = reducer(state, action)

    if (!environment.production) {
      console.group(action.type)
      console.log(`%c prev state`, `color: #9E9E9E; font-weight: bold`, state)
      console.log(`%c action`, `color: #03A9F4; font-weight: bold`, action)
      console.log(`%c next state`, `color: #4CAF50; font-weight: bold`, nextState)
      console.groupEnd()
    }
    return nextState
  }
}

export const metaReducers = [debug]
